import { ImagesData } from "@ts/data/ImagesData";
import { simpleForm } from "../core/SimpleForm";
import { uploadFile } from "../core/uploadFile";
import { Utils } from "../core/Utils";
import { AbstractSection } from "./AbstractSection";

export class ImageSection extends AbstractSection {

    public constructor(section:ImagesData) {
        super(section);
        this.renderTarget.classList.add('image-wrapper');
    }

    protected onViewRender(): void {

        const data = this.data as ImagesData;
        this.renderTarget.innerHTML = '';
        console.log(data);

        const div = document.createElement('div');
        div.className = 'clicknote';
        div.innerHTML = `Klicka på bilden för att se originalet`;
        this.renderTarget.appendChild(div);

        const img = document.createElement('img');
        img.id = 'image-src';
        img.src = data.imagefile;
        this.renderTarget.appendChild(img);
        
        img.addEventListener( 'load', (e:Event) => {
            e.preventDefault();

            if( data.size > 0 && data.size <= 100 ) {
                img.style.height = img.style.width = `${data.size}%`;
            }
            else {
                img.style.height = img.style.width =' 100%';
            }
            img.style.transform = `rotate(${data.rotation}deg)`;
            if (data.shadow) img.classList.add('shadow');
            else img.classList.remove('shadow');
    
            if (data.rotation === 90 || data.rotation === 270) {
                img.style.height = `${img.offsetHeight}px`;
                img.style.width = `${img.offsetWidth}px`;
            }
            
            img.addEventListener('click', (e: Event) => {
                e.preventDefault();
                this.renderFullscreen(img);
            });
        });
        
        const comment = document.createElement('figcaption');
        comment.id = 'image-comment';
        comment.innerText = data.comment;
        this.renderTarget.append(comment);

    }

    protected onEditRender(): void {

        const data = this.data as ImagesData;
        this.renderTarget.innerHTML = '';

        const img = document.createElement('img');
        this.renderTarget.append(img);
        img.id = 'image-src';
        img.style.height = img.style.width = img.style.width === '' ? '100%' : `${data.size}%`;
        img.style.transform = `rotate(${data.rotation}deg)`;
        img.src = data.imagefile;
        if (data.shadow) img.classList.add('shadow');
        else img.classList.remove('shadow');
        
        const comment = document.createElement('figcaption');
        comment.id = 'image-comment';
        comment.innerText = data.comment;
        this.renderTarget.appendChild(comment);

        if (this.tbar) {
            this.tbar.add('Byt bild',
                `Klicka för att byta bilden till en annan. Om bilden du laddar upp är större än 1920x1920 pixels
                skalas den ned till den storleken`,
                'image', () => {
                    uploadFile('image', this.pageName)
                        .then((resolve: string | false) => {
                            if (resolve) {
                                img.src = resolve;
                                Utils.forceRefresh(img);
                            }
                        });
                });
            this.tbar.add('Ändra kommentar',
                `Här kan du lägga till en kommentar. Vill du ingen ha så lämna skrivfältet tomt. Kommentaren
                kan vara fler än en rad om du så vill`,
                'comment', async () => {
                    const commentElement = this.renderTarget.querySelector('#image-comment') as HTMLElement;
                    await simpleForm('Bild', 4, 'Ändra kommentar', commentElement.innerText, 'Min kommentar')
                        .then((text: string) => {
                            commentElement.innerText = text;
                            Utils.forceRefresh(commentElement);
                        });
                });
            this.tbar.add('Öka storlek',
                `Öka bildens storlek`,
                'incr', () => {
                    const img = this.renderTarget.querySelector('img') as HTMLImageElement;
                    let size = parseInt(img.style.height);
                    if (size === 0 || Number.isNaN(size)) size = 10;
                    if (size < 100) size += 10;
                    img.style.height = img.style.width = `${size}%`;
                    Utils.forceRefresh(img);

                });
            this.tbar.add('Minska storlek',
                `Minska bildens storlek`,
                'decr', () => {
                    const img = this.renderTarget.querySelector('img') as HTMLImageElement;
                    let size = parseInt(img.style.height);
                    if (size === 0 || Number.isNaN(size)) size = 20;
                    if (size > 10) size -= 10;
                    img.style.height = img.style.width = `${size}%`;
                    Utils.forceRefresh(img);
                });
            this.tbar.add('Rotera',
                `Rotera bilden`,
                'rot', () => {
                    const img = this.renderTarget.querySelector('img') as HTMLImageElement;
                    let rot = parseInt(img.style.transform.substring('rotate('.length));
                    if (Number.isNaN(rot)) rot = 0;
                    rot += 90;
                    if (rot > 270) rot = 0;
                    img.style.transform = `rotate(${rot}deg)`;
                    if (rot === 90 || rot === 270) {
                        this.sectionElement.style.height = `${img.offsetHeight}px`;
                    }
                    Utils.forceRefresh(img);
                });
            this.tbar.add('Skugga',
                `Växla mellan skugga eller ingen skugga`,
                `shadow`, () => {
                    const img = this.renderTarget.querySelector('img') as HTMLImageElement;
                    if (img) {
                        Utils.toggleCss(img,'shadow');
                        Utils.forceRefresh(img);
                    }

                }
            );
        }
    }

    protected parseContent(): void {
        const img = this.renderTarget.querySelector('img') as HTMLImageElement;
        (this.data as ImagesData).shadow = img.classList.contains('shadow');
        (this.data as ImagesData).imagefile = Utils.stripHost(img.src);
        (this.data as ImagesData).size = parseInt(img.style.width);
        (this.data as ImagesData).rotation = parseInt(img.style.transform.substring('rotate('.length));

        const comment = this.renderTarget.querySelector('figcaption') as HTMLElement;
        (this.data as ImagesData).comment = comment.innerText;

    }

    private renderFullscreen(img: HTMLImageElement): void {

        const wrapper = document.createElement('div');
        wrapper.className = 'fullscreen-image';

        const fimg = document.createElement('img');
                wrapper.appendChild(fimg);
        fimg.src = img.src;
        fimg.addEventListener( 'load', () => {
            wrapper.addEventListener('click', (e:Event) => {
                e.preventDefault();
                document.body.removeChild(wrapper);
            });
            document.body.appendChild(wrapper);
        });
    }
}
